import { apiClient } from './apiClient';

export const contractService = {
  // Get all contracts
  async getContracts() {
    return apiClient.get(`/api/cmms/contracts`);
  },

  // Get contracts by status
  async getContractsByStatus(status) {
    return apiClient.get(`/api/cmms/contracts/status/${status}`);
  },

  // Get contracts by supplier
  async getContractsBySupplier(supplierId) {
    return apiClient.get(`/api/cmms/contracts/supplier/${supplierId}`);
  },

  // Get active contracts
  async getActiveContracts() {
    return apiClient.get(`/api/cmms/contracts/active`);
  },

  // Get expiring contracts
  async getExpiringContracts(daysAhead = 30) {
    return apiClient.get(`/api/cmms/contracts/expiring?daysAhead=${daysAhead}`);
  },

  // Get single contract by ID
  async getContractById(id) {
    return apiClient.get(`/api/cmms/contracts/${id}`);
  },

  // Create new contract
  async createContract(data) {
    return apiClient.post(`/api/cmms/contracts`, data);
  },

  // Update contract
  async updateContract(id, data) {
    return apiClient.put(`/api/cmms/contracts/${id}`, data);
  },

  // Delete contract
  async deleteContract(id) {
    return apiClient.delete(`/api/cmms/contracts/${id}`);
  },

  // Add assets to contract
  async addAssets(contractId, assetIds, notes = null) {
    return apiClient.post(`/api/cmms/contracts/${contractId}/assets`, {
      assetIds,
      notes,
    });
  },

  // Remove asset from contract
  async removeAsset(contractId, assetId) {
    return apiClient.delete(`/api/cmms/contracts/${contractId}/assets/${assetId}`);
  },

  // Get contract files
  async getContractFiles(contractId) {
    return apiClient.get(`/api/cmms/contracts/${contractId}/files`);
  },

  // Upload file to contract
  async uploadFile(contractId, file, description = null, uploadedBy = null) {
    const formData = new FormData();
    formData.append('file', file);
    if (description) formData.append('description', description);
    if (uploadedBy) formData.append('uploadedBy', uploadedBy);

    return apiClient.upload(`/api/cmms/contracts/${contractId}/files`, formData);
  },

  // Delete file from contract
  async deleteFile(contractId, fileId) {
    return apiClient.delete(`/api/cmms/contracts/${contractId}/files/${fileId}`);
  },
};
